import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex d-lg-block flex-column bg-dark text-light text-center rounded-0 cookiealert py-5" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" We use cookies or similar technologies as specified in the cookie policy. You can consent to the use of such technologies by clicking the button or by continuing to browse otherwise. You can learn more about this in our ")
const _hoisted_3 = /*#__PURE__*/_createElementVNode("a", {
  href: "/cookie-policy",
  target: "_blank"
}, "Cookie Policy", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('agree'))),
      class: "btn btn-primary d-inline mx-auto ms-lg-5 acceptcookies mt-5 mt-lg-0"
    }, " I agree ")
  ]))
}